import { render, staticRenderFns } from "./CampaignCard.vue?vue&type=template&id=3cd45e30&"
import script from "./CampaignCard.vue?vue&type=script&lang=js&"
export * from "./CampaignCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports